export default __webpack_public_path__ + "static/cruiselines-vv-activities-2-29c970c91948155bb5992e1f85f2828c.jpg";